// 스타일 썸네일 주소. 화면에는 520px WebP 사본(sm/)을 쓰고, 깨지면 원본 800px
// jpg 로 한 번 갈아 끼운다. 사본은 scripts/build-style-thumbs-sm.mjs 가 만든다.
const DIR = { exterior: '/exterior-thumbnails', garden: '/garden-thumbnails' };

const dirFor = (category) => DIR[category] || '/style-thumbnails';

export function styleThumb(category, key) {
  return `${dirFor(category)}/sm/${key}.webp`;
}

export function styleThumbFallback(category, key) {
  const full = `${dirFor(category)}/${key}.jpg`;
  return (e) => {
    if (!e.currentTarget.src.endsWith(full)) e.currentTarget.src = full;
  };
}
